import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !cfg.url?.includes("/auth/refresh") && !cfg.url?.includes("/auth/login")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (_) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail ?? e?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d.message === "string") return d.message;
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

const AI_ERROR_MARKER = "\u0000AI_ERROR:";

export const streamAgent = (agent, body, onChunk) => streamPost(`/ai/agents/${agent}/stream`, body, onChunk);

export async function streamPost(path, body, onChunk, retried = false) {
  const res = await fetch(`${API}${path}`, {
    method: "POST", credentials: "include",
    headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
  });
  if (res.status === 401 && !retried) {
    await api.post("/auth/refresh");
    return streamPost(path, body, onChunk, true);
  }
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw { detail: data.detail || `Request failed (${res.status})` };
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    const chunk = decoder.decode(value, { stream: true });
    const idx = chunk.indexOf(AI_ERROR_MARKER);
    if (idx >= 0) {
      if (idx > 0) onChunk(chunk.slice(0, idx));
      throw { detail: chunk.slice(idx + AI_ERROR_MARKER.length) };
    }
    onChunk(chunk);
  }
}

export const money = (v) => (v == null ? null : `$${Math.round(v / 1000)}k`);
export const salaryText = (j) => (j.salary_max ? `${money(j.salary_min)}–${money(j.salary_max)}` : "Salary not disclosed");
const LABELS = { ic: "Individual contributor", senior_ic: "Senior individual contributor", c_suite: "C-suite", vp: "VP", external_ats: "External ATS",
  linkedin_assisted: "LinkedIn (assisted)", candidate_link: "Candidate link", candidate_reported: "Candidate reported" };
export const label = (s) => LABELS[s] || (s || "").replace(/_/g, " ");

export function ago(iso) {
  if (!iso) return "never";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 3600) return `${Math.max(1, Math.round(s / 60))}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
}

export const homeFor = (u) => (u.role === "admin" ? "/admin" : u.role === "recruiter" ? "/recruiter" : "/app");
